import type { ContainerType } from "~/container";
import type { IApi } from "~/interfaces/IApi";
import type { ILostAndFoundService } from "@saif-reporting/domain/interfaces/services/ILostAndFoundService.js";
import type {
  LostAndFoundItemListQuery,
  LostAndFoundItemCreateRequest,
  LostAndFoundItemHandoverRequest,
} from "@saif-reporting/domain/dtos/lostAndFoundItemDtos.js";
import type { LostAndFoundItemDto } from "@saif-reporting/domain/dtos/models/LostAndFoundItemDto.js";
import type { Paginated } from "@saif-reporting/domain/dtos/Paginated.js";

export class LostAndFoundService implements ILostAndFoundService {
  private readonly api: IApi;
  constructor({ baseApi }: ContainerType) {
    this.api = baseApi;
  }

  async getList(query: LostAndFoundItemListQuery): Promise<Paginated<LostAndFoundItemDto>> {
    return await this.api.$fetch<Paginated<LostAndFoundItemDto>>("/lost-and-found", {
      query,
    });
  }

  async view(id: number): Promise<LostAndFoundItemDto> {
    return await this.api.$fetch<LostAndFoundItemDto>(`/lost-and-found/${id}`);
  }

  async create(dto: LostAndFoundItemCreateRequest, images: File[]): Promise<LostAndFoundItemDto> {
    const formData = new FormData();
    formData.append("title", dto.title);
    formData.append("itemDetail", dto.itemDetail);
    images.forEach((img) => {
      formData.append("images", img);
    });

    return await this.api.$fetch<LostAndFoundItemDto>(`/lost-and-found`, {
      method: "post",
      body: formData,
    });
  }

  async handover(id: number, dto: LostAndFoundItemHandoverRequest): Promise<LostAndFoundItemDto> {
    return await this.api.$fetch<LostAndFoundItemDto>(`/lost-and-found/${id}/handover`, {
      method: "patch",
      body: dto,
    });
  }

  async delete(id: number): Promise<LostAndFoundItemDto> {
    return await this.api.$fetch<LostAndFoundItemDto>(`/lost-and-found/${id}`, {
      method: "delete",
    });
  }
}
